import styled from "styled-components";

export const AppBarTitleHolder = styled.div`
  justify-self: center;
`;
